/**
 * Date formatting utilities
 */

/**
 * Format date to YYYY-MM-DD string
 * @param {Date} date - Date object to format
 * @returns {string} - Date string in YYYY-MM-DD format
 */
export const formatDateToString = (date) => {
  const d = new Date(date);
  return d.toISOString().split('T')[0];
};

/**
 * Parse a timestamp from the API. The backend stores UTC but serialises it
 * without a zone ("2026-09-23T19:31:16"), which `new Date()` would read as
 * local time — showing it hours off. Treat zone-less values as UTC; values
 * that already carry "Z" or an offset are left as they are.
 * @param {string|Date|null} value
 * @returns {Date|null} Date in the browser's local time zone
 */
export const parseApiTimestamp = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  const hasZone = /(Z|[+-]\d{2}:?\d{2})$/i.test(value);
  const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(value);
  return new Date(hasZone || isDateOnly ? value : `${value}Z`);
};
